import { Input } from '@consigli/shadcn';
import { FC } from 'react';

import { Field } from '@/components';

interface TemplateMetadataFieldsProps {
  name: string;
  reportType: string;
  projectType: string;
  location: string;
  onNameChange: (value: string) => void;
  onReportTypeChange: (value: string) => void;
  onProjectTypeChange: (value: string) => void;
  onLocationChange: (value: string) => void;
  disabled?: boolean;
  showError?: boolean;
}

/**
 * Shared metadata fields for report template forms.
 * Used in both create and edit forms to ensure consistency.
 */
export const TemplateMetadataFields: FC<TemplateMetadataFieldsProps> = ({
  name,
  reportType,
  projectType,
  location,
  onNameChange,
  onReportTypeChange,
  onProjectTypeChange,
  onLocationChange,
  disabled = false,
  showError = false,
}) => {
  return (
    <>
      <Field
        htmlFor="template-name"
        label="Template Name"
        required
        error={!name && showError ? 'Name is required' : undefined}
      >
        <Input
          id="template-name"
          type="text"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="e.g., CBS Template - London"
          disabled={disabled}
        />
      </Field>

      <Field
        htmlFor="report-type"
        label="Report Type"
        required
        error={!reportType && showError ? 'Report type is required' : undefined}
      >
        <Input
          id="report-type"
          type="text"
          value={reportType}
          onChange={(e) => onReportTypeChange(e.target.value)}
          placeholder="e.g., CBS, ECO, WLC"
          disabled={disabled}
        />
        <p className="mt-1 text-sm text-gray-500">Common types: CBS, ECO, WLC, FDV, O&M</p>
      </Field>

      <Field
        htmlFor="project-type"
        label="Project Type"
        required
        error={!projectType && showError ? 'Project type is required' : undefined}
      >
        <Input
          id="project-type"
          type="text"
          value={projectType}
          onChange={(e) => onProjectTypeChange(e.target.value)}
          placeholder="e.g., planning-applications, transportation, building"
          disabled={disabled}
        />
      </Field>

      <Field
        htmlFor="location"
        label="Location"
        required
        error={!location && showError ? 'Location is required' : undefined}
      >
        <Input
          id="location"
          type="text"
          value={location}
          onChange={(e) => onLocationChange(e.target.value)}
          placeholder="e.g., GREATER-LONDON-UK, NYC, OSLO-NO"
          disabled={disabled}
        />
      </Field>
    </>
  );
};
